import React from 'react';
import styles from './testimonial.module.css';

const allTestimonials = [
  {
    id: 1,
    text: "Learning keyboard under Kamal Sir has been a wonderful experience. He is patient, encouraging & ensures steady progress.Vibe musicals offers many instruments with well-maintained facilities & the annual concert gave students a great platform to perform confidently. Highly recommended for music learners.",
    author: " harini pg ",
    role: "keyboard players",
    rating: 5,
    source: "Google",
    image: "https://ui-avatars.com/api/?name=harini+pg&background=0a1a1f&color=fff"
  },
  {
    id: 2,
    text: "I am learning keyboard here, I am working mom with 2 kids, I would recommend all of you go ahead with learning musical instrument in Vibe musicals. Really appreciate Kamal Sir’s easy way of teaching and helping with flexible time of class.",
    author: " PUJA KUMARI",
    role: "keyboard players",
    rating: 5,
    source: "Google",
    image: "https://ui-avatars.com/api/?name=Puja+Kumari&background=0a1a1f&color=fff"
  },
  {
    id: 3,
    text: "The Vibe Musicals annual concert was a vibrant blend of talent, passion, and harmony, showcasing the hard work of every performer.",
    author: " Nandhini Mahendran",
    role: " Client",
    rating: 5,
    source: "Whatsapp",
    image: "https://ui-avatars.com/api/?name=Nandhini+Mahendran&background=0a1a1f&color=fff"
  },
  {
    id: 4,
    text: "My daughter has been taking classes with Vibe musical’s Kamal for almost 6 months now. The instructor has been patient and teaches intuitively, understanding her level and ability. Remarkable comfort and improvement in her skill.",
    author: " Akshaya Vikram",
    role: " Parent",
    rating: 5,
    source: "Google",
    image: "https://ui-avatars.com/api/?name=Akshaya+Vikram&background=0a1a1f&color=fff"
  },
  {
    id: 5,
    text: "I wanted to give a surprise gift to my daughter’s 15 th birthday with her recent inspiration from a fellow schoolmate’s violin performance. I dialled to vibe musicals and spoke to Kamal and explained about it.",
    author: " Sivasankar R",
    role: "violin player",
    rating: 5,
    source: "Google",
    image: "https://ui-avatars.com/api/?name=Sivasankar+R&background=0a1a1f&color=fff"
  },
  {
    id: 6,
    text: "A wide range of instruments are covered with equal attention for each student. My child had no knowledge on music when I enrolled him for keyboard class at Vibe musicals but now he is enjoying the class and loves playing keyboard.",
    author: " Akhila S",
    role: "Parent",
    rating: 5,
    source: "Google",
    image: "https://ui-avatars.com/api/?name=Akhila+S&background=0a1a1f&color=fff"
  },
  {
    id: 7,
    text: "Great place to learn music for all ages!!! Masters here are very friendly, patience towards learners. The kids who learn music from here will get wonderful learning experience.",
    author: " simb4u",
    role: " Client",
    rating: 5,
    source: "Google",
    image: "https://ui-avatars.com/api/?name=simb4u&background=0a1a1f&color=fff"
  },
  {
    id: 8,
    text: "Mr. Kamal is a very good teacher, he teaches patiently and created a friendly atmosphere for my child to grow her love of music",
    author: " jayita manna",
    role: "Parent",
    rating: 4,
    source: "Whatsapp",
    image: "https://ui-avatars.com/api/?name=jayita+manna&background=0a1a1f&color=fff"
  },
  {
    id: 9,
    text: "Good place to learn music instruments like Keyboard 🎹, drums, guitar 🎸, violin 🎻. I'm learning Violin from here. Very good teaching and worth for money 💰.",
    author: "Gaunolla Kalpana",
    role: "guitar player",
    rating: 5,
    source: "Google",
    image: "https://ui-avatars.com/api/?name=Gaunolla+Kalpana&background=0a1a1f&color=fff"
  },
  {
    id: 10,
    text: "My daughter is attending keyboard classes from the past two months and we are satisfied by the way Kamal takes care of every student and provides regular feedback.",
    author: "satyanarayana murthy",
    role: "parent",
    rating: 5,
    source: "Google",
    image: "https://ui-avatars.com/api/?name=satyanarayana+murthy&background=0a1a1f&color=fff"
  },
  {
    id: 11,
    text: "I am learning violin in Vibe musicals. Kamal sir is a good music teacher. Thank you for creating a positive and motivating learning environment.",
    author: " NAVEEN M",
    role: "violin player",
    rating: 5,
    source: "Google",
    image: "https://ui-avatars.com/api/?name=NAVEEN+M&background=0a1a1f&color=fff"
  },
  {
    id: 12,
    text: "Vibe Musicals provides a supportive and dynamic environment for my sons that nurtures growth and passion for music.",
    author: " Badraveni C P",
    role: "parent",
    rating: 5,
    source: "Google",
    image: "https://ui-avatars.com/api/?name=Badraveni+C+P&background=0a1a1f&color=fff"
  },
];

const testimonialsColumn1 = allTestimonials.slice(0, 4);
const testimonialsColumn2 = allTestimonials.slice(4, 8);
const testimonialsColumn3 = allTestimonials.slice(8, 12);

const Testimonials = () => {
  const renderTestimonials = (testimonialsArray) => (
    <>
      {testimonialsArray.map((testimonial, index) => (
        <div key={`${testimonial.id}-${index}`} className={styles.testimonialCard}>
          <div className={styles.rating}>
            {Array(testimonial.rating).fill().map((_, i) => (
              <span key={i}>&#9733;</span>
            ))}
          </div>
          
          <p className={styles.testimonialText}>"{testimonial.text}"</p>
          
          <div 
            className={styles.authorInfo} 
            style={{ '--author-image': `url(${testimonial.image})` }}
          >
            <span className={styles.authorName}>{testimonial.author}</span>
            <span className={styles.authorRole}>{testimonial.role}</span>
          </div>
        </div>
      ))}
    </>
  );

  return (
    <section className={styles.testimonialsSection}>
      <h2 className={styles.sectionHeading}>Hear From Our Success Stories</h2>
      <p className={styles.sectionSubtitle}>
        Our students' achievements speak volumes about the quality of our training.
      </p>

      <div className={styles.carouselContainer}>
        <div className={styles.testimonialColumn}>
          <div className={`${styles.testimonialsTrack} ${styles.scrollUp}`}>
            {renderTestimonials([...testimonialsColumn1, ...testimonialsColumn1])}
          </div>
        </div>

        <div className={styles.testimonialColumn}>
          <div className={`${styles.testimonialsTrack} ${styles.scrollDown}`}>
            {renderTestimonials([...testimonialsColumn2, ...testimonialsColumn2])}
          </div>
        </div>

        <div className={styles.testimonialColumn}>
          <div className={`${styles.testimonialsTrack} ${styles.scrollUp}`}>
            {renderTestimonials([...testimonialsColumn3, ...testimonialsColumn3])}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;